import { render, staticRenderFns } from "./paginations.vue?vue&type=template&id=d228b9a6&scoped=true"
import script from "./paginations.vue?vue&type=script&lang=js"
export * from "./paginations.vue?vue&type=script&lang=js"
import style0 from "./paginations.vue?vue&type=style&index=0&id=d228b9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d228b9a6",
  null
  
)

export default component.exports